import React, { useState } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, Tab, Tabs, Card } from '@nextui-org/react';
import { useAuth } from '../../hooks/useAuth';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

const AuthModal: React.FC = () => {
    const { showAuthModal, setShowAuthModal } = useAuth();
    const [selected, setSelected] = useState<string>("login");

    return (
        <Modal
            isOpen={showAuthModal}
            onClose={() => setShowAuthModal(false)}
            size='md'
            placement='center'
            backdrop='blur'
            classNames={{
                body: "py-6",
                backdrop: "bg-black/50 backdrop-blur-sm",
                base: "border-[#292f46] bg-white dark:bg-gray-900",
                header: "border-b-[1px] border-[#292f46]",
                closeButton: "hover:bg-white/5 active:bg-white/10"
            }}
        >
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className='flex flex-col gap-1'>
                            Authentication
                        </ModalHeader>
                        <ModalBody>
                            <Card className="mb-4 bg-blue-50 border border-blue-200 dark:bg-blue-900/20 dark:border-blue-800">
                                <div className="p-4 flex items-start gap-3">
                                    <div className="flex-shrink-0 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                                        <span className="text-white text-sm font-bold">i</span>
                                    </div>
                                    <p className="text-blue-800 dark:text-blue-200 text-sm">
                                        Login is optional, but authenticated users can add rich text notes, edit their notes, mark videos as favorites, and track completion progress.
                                    </p>
                                </div>
                            </Card>
                            <Tabs
                                selectedKey={selected}
                                onSelectionChange={(key) => setSelected(key as string)}
                                aria-label='Authentication forms'
                                fullWidth
                                size='lg'
                                variant='underlined'
                                classNames={{
                                    tabList: "gap-4 w-full relative rounded-none p-0 border-b border-divider",
                                    cursor: "w-full bg-primary h-[2px]",
                                    tab: "max-w-fit px-0 h-12",
                                    tabContent: "group-data-[selected=true]:text-primary"
                                }}
                            >
                                <Tab key='login' title='Login'>
                                    <LoginForm />
                                </Tab>
                                <Tab key='signup' title='Sign Up'>
                                    <SignupForm />
                                </Tab>
                            </Tabs>
                        </ModalBody>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default AuthModal; 